<template>
    <div class="card card-body shadow-sm mt-0">
      <div class="form-header d-flex justify-content-between align-items-center">
        <h4 class="form-title">{{ plano.id ? "Editar Plano de Conta" : "Novo Plano de Conta" }}</h4>
        <button class="btn btn-secondary btn-sm me-3" @click="voltar">Voltar</button>
      </div>
      <BaseForm 
        :submitText="plano.id ? 'Salvar' : 'Salvar'"
        :cancelText="'Cancelar'"
        :isFormValid="isFormValid" 
        :isSubmitting="isSubmitting"
        @submit="salvarPlano" 
        @cancel="voltar"
      >
        <!-- Dados do Plano de Conta -->
        <FormSection title="Informações do Plano de Conta">
          <div class="d-flex justify-content-between">
            <div class="form-group flex-grow-1 me-3">
              <label for="nome">Nome <span class="required">*</span></label>
              <input
                id="nome"
                type="text"
                v-model="plano.nome"
                class="form-control"
                :class="{ 'error-input': errors.nome }"
                placeholder="Digite o nome do plano"
              />
              <span v-if="errors.nome" class="error-message">{{ errors.nome }}</span>
            </div>
            
            <div class="form-group flex-grow-1 me-3">
              <label for="tipo">Tipo <span class="required">*</span></label>
              <select
                id="tipo"
                v-model="plano.tipo"
                class="form-select"
              >
                <option disabled value="">Selecione o tipo</option>
                <option v-for="opcao in opcoesTipo" :key="opcao.value" :value="opcao.value">
                  {{ opcao.text }}
                </option>
              </select>
              <span v-if="errors.tipo" class="error-message">{{ errors.tipo }}</span>
            </div>
  
            <div class="form-group">
              <label for="status">Status <span class="required">*</span></label>
              <div class="form-switch">
                <input
                  type="checkbox"
                  id="status"
                  v-model="plano.ativo"
                  class="form-check-input"
                />
                <label for="status" class="form-check-label">
                  {{ plano.ativo ? "Ativo" : "Inativo" }}
                </label>
              </div>
            </div>
          </div>
        </FormSection>
  
        <FormSection title="Descrição do Plano de Conta">
          <div class="form-group mt-3 w-100">
            <label for="descricao">Descrição</label>
            <textarea
              id="descricao"
              v-model="plano.descricao"
              class="form-control"
              placeholder="Digite a descrição do plano"
              rows="3"
              style="width: 100%;"
            ></textarea>
          </div>
        </FormSection>

      </BaseForm>
    </div>
  </template>
  
  <script>
  import { reactive, ref, computed, onMounted } from "vue";
  import { useRouter, useRoute } from "vue-router";
  import axios from "@/services/axios";
  import BaseForm from "@/components/Layout/BaseForm.vue";
  import FormSection from "@/components/Layout/FormSection.vue";
  
  export default {
    components: { BaseForm, FormSection },
    setup() {
      const router = useRouter();
      const route = useRoute();
  
      const plano = reactive({
        id: null,
        nome: "",
        tipo: "",
        descricao: "",
        ativo: true,
      });
  
      const opcoesTipo = ref([
        { value: "Receita", text: "Receita" },
        { value: "Despesa", text: "Despesa" },
      ]);
  
      const errors = reactive({});
      const isSubmitting = ref(false);
  
      const carregarPlano = async () => {
        const id = route.params.id;
        if (!id) return;
  
        try {
          const response = await axios.get(`/financeiro/planos-contas/${id}`);
          Object.assign(plano, response.data);
        } catch (error) {
          console.error("Erro ao carregar plano de conta:", error);
        }
      };
  
      const validateForm = () => {
        errors.nome = plano.nome ? "" : "O nome é obrigatório.";
        errors.tipo = plano.tipo ? "" : "O tipo é obrigatório.";
      };
  
      const isFormValid = computed(() => {
        return Boolean(
          !Object.values(errors).some((error) => error) &&
          plano.nome &&
          plano.tipo
        );
      });
  
      const salvarPlano = async () => {
        if (isSubmitting.value) return;
  
        validateForm();
  
        if (!isFormValid.value) {
          console.error("O formulário contém erros:", errors);
          return;
        }
  
        isSubmitting.value = true;
        try {
          const method = plano.id ? "put" : "post";
          const url = plano.id
            ? `/financeiro/planos-contas/${plano.id}`
            : "/financeiro/planos-contas";
  
          await axios[method](url, plano);
  
          router.push("/financeiro/planos-contas");
        } catch (error) {
          console.error("Erro ao salvar plano de conta:", error);
        } finally {
          isSubmitting.value = false;
        }
      };
  
      const voltar = () => {
        router.push("/financeiro/planos-contas");
      };
  
      onMounted(() => {
        carregarPlano();
      });
  
      return {
        plano,
        opcoesTipo,
        errors,
        isFormValid,
        isSubmitting,
        salvarPlano,
        voltar,
      };
    },
  };
  </script>
      
  <style scoped>
  .form-container {
    max-width: 90%;
    margin: 0 auto;
    padding: 20px;
    border: 1px solid #ddd;
    border-radius: 8px;
    background-color: #fff;
  }
  

  .form-group {
    margin-bottom: 15px;
  }
  
  .required {
    color: red;
  }
  
  .form-switch {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  
  </style>
